module.exports = __webpack_public_path__ + "static/img/grade_1.fcad6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_1.png
// module id = h4Jn
// module chunks = 89